import Monitoring from "./Monitoring.view";

export default Monitoring;
